import { render, staticRenderFns } from "./CreateReceiveForm.vue?vue&type=template&id=cdf9b99c&scoped=true"
import script from "./CreateReceiveForm.vue?vue&type=script&lang=js"
export * from "./CreateReceiveForm.vue?vue&type=script&lang=js"
import style0 from "./CreateReceiveForm.vue?vue&type=style&index=0&id=cdf9b99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf9b99c",
  null
  
)

export default component.exports